<template functional>
  <div>
    <el-tag
      v-if="props.row.type_contract"
      class="text-left"
      style="height: auto"
      :type="props.row.contract_end_date ? 'warning' : 'info'"
    >
      <translate-text keyTranslate="common_words.type" />
      {{ props.row.type_contract.name }}
      <br />
      <translate-text keyTranslate="common_words.beginning" />:
      <template v-if="props.row.contract_start_date">
        {{ props.row.contract_start_date }}
      </template>
      <template v-else>
        <translate-text keyTranslate="common_words.no_assignment" />
      </template>
      <template v-if="props.row.contract_end_date">
        <br />
        <translate-text keyTranslate="common_words.end" />:
        {{ props.row.contract_end_date }}
      </template>
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'FieldFormatter',
};
</script>
